import { Panel, Separator } from 'react-resizable-panels'

import { useNavigateToCurrentTemplatePath } from '../../components/templateFieldsTable/useNavigateToCurrentTemplatePath'
import { useLayoutContext } from '../../context/layoutContext'
import { useTemplateContext } from '../../context/templateContext'
import { TemplateDetailsRightSideBar } from './TemplateDetailsRightSideBar'

export const TemplateDetailsRightSidebarPanel = () => {
  const { viewingDetails } = useTemplateContext()
  const {
    preferences: {
      common: { isUsingModal },
    },
  } = useLayoutContext()
  const navigateToPath = useNavigateToCurrentTemplatePath()

  return viewingDetails && !isUsingModal ? (
    <>
      <Separator
        id="resizeTemplateDetails"
        className="w-1 dark:bg-slate-700 bg-slate-300"
      />
      <Panel
        id="templateDetailsPanel"
        className="size-full overflow-hidden max-h-full"
        minSize="5%"
        defaultSize="25%"
      >
        <TemplateDetailsRightSideBar onClose={() => navigateToPath('')} />
      </Panel>
    </>
  ) : null
}
